import React from "react";
import { History } from "lucide-react";

/**
 * Recent Transactions Panel
 * 
 * Shows recent wallet transactions.
 */
export function RecentTransactions({ transactions }) {
  return (
    <div className="border border-border">
      <div className="p-4 border-b border-border bg-muted/30">
        <h3 className="font-bold">Recent Transactions</h3>
      </div>
      {transactions?.length > 0 ? (
        <div className="divide-y divide-border">
          {transactions.slice(0, 10).map((txn, index) => (
            <div key={txn.id || txn.transaction_id || index} className="p-4 flex justify-between items-center">
              <div>
                <p className="font-medium">{txn.description}</p>
                <p className="text-xs text-muted-foreground">
                  {txn.created_at?.slice(0, 16).replace("T", " ")}
                </p>
              </div>
              <span className={`font-bold ${txn.type === 'credit' || txn.amount > 0 ? 'text-emerald-600' : 'text-red-600'}`}>
                {txn.type === 'credit' || txn.amount > 0 ? '+' : ''}₹{Math.abs(txn.amount)}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <div className="p-8 text-center text-muted-foreground">
          <History className="w-12 h-12 mx-auto mb-3 opacity-30" />
          <p>No transactions yet</p>
        </div>
      )}
    </div>
  );
}
